import { ReserveProductDetail } from '@features/reserve-in-store/reserve-in-store';

export const hasOutOfStockLines = (lines: ReserveProductDetail[]): boolean =>
    lines.some(line => line.lineType === 'OutOfStockRange') || false;
